const LOADING_KEY = 'loadingState';

export const saveLoadingState = (isLoading: boolean, text: string) => {
  localStorage.setItem(LOADING_KEY, JSON.stringify({isLoading, text}));
};

export const loadLoadingState = (): {isLoading: boolean; text: string} => {
  const storedState = localStorage.getItem(LOADING_KEY);
  if (storedState) {
    return JSON.parse(storedState);
  }
  return {isLoading: false, text: ''};
};

export const clearLoadingState = () => {
  localStorage.removeItem(LOADING_KEY);
};
